import MyStoresPlanogramCompliance from "./MyStoresPlanogramCompliance";
export default MyStoresPlanogramCompliance;
